"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import * as builtins from "timvir/builtins";
import { makeBus } from "timvir/bus";
import { Provider } from "timvir/context";
import { layoutStyles } from "../../layout";
import { Commands } from "../Commands";
import { NavigationFooter } from "../NavigationFooter";
import { Sidebar } from "./internal";
/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
export function Page(props) {
  const $ = _c(65);
  let Footer;
  let Link;
  let blocks;
  let children;
  let location;
  let mdxComponents;
  let navigationProp;
  let rest;
  let search;
  let toc;
  if ($[0] !== props) {
    ({
      toc,
      location,
      Link,
      navigation: navigationProp,
      search,
      mdxComponents,
      Footer,
      blocks,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = Footer;
    $[2] = Link;
    $[3] = blocks;
    $[4] = children;
    $[5] = location;
    $[6] = mdxComponents;
    $[7] = navigationProp;
    $[8] = rest;
    $[9] = search;
    $[10] = toc;
  } else {
    Footer = $[1];
    Link = $[2];
    blocks = $[3];
    children = $[4];
    location = $[5];
    mdxComponents = $[6];
    navigationProp = $[7];
    rest = $[8];
    search = $[9];
    toc = $[10];
  }
  let navigation;
  if ($[11] !== Link || $[12] !== location || $[13] !== navigationProp) {
    if (navigationProp) {
      navigation = navigationProp;
    } else {
      if (location && Link) {
        let t0;
        if ($[15] !== location) {
          t0 = () => new URL(location.asPath, "http://localhost").pathname;
          $[15] = location;
          $[16] = t0;
        } else {
          t0 = $[16];
        }
        navigation = {
          usePathname: t0,
          Link
        };
      } else {
        throw new Error("timvir/core: 'Page' requires either the 'navigation' prop, or both 'location' and 'Link'.");
      }
    }
    $[11] = Link;
    $[12] = location;
    $[13] = navigationProp;
    $[14] = navigation;
  } else {
    navigation = $[14];
  }
  let t0;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      search: {
        open: false
      }
    };
    $[17] = t0;
  } else {
    t0 = $[17];
  }
  const [state, setState] = React.useState(t0);
  const [bus] = React.useState(makeBus);
  navigation;
  let t1;
  if ($[18] !== mdxComponents) {
    t1 = {
      ...builtins,
      ...mdxComponents
    };
    $[18] = mdxComponents;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  let t2;
  if ($[20] !== blocks || $[21] !== bus || $[22] !== navigation || $[23] !== t1 || $[24] !== toc) {
    t2 = {
      bus,
      articleComponents: t1,
      navigation,
      blocks,
      toc
    };
    $[20] = blocks;
    $[21] = bus;
    $[22] = navigation;
    $[23] = t1;
    $[24] = toc;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  const context = t2;
  let t3;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      modifiers: ["meta"],
      key: "p"
    };
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  if ($[27] !== state.search.open) {
    t4 = ev => {
      ev.preventDefault();
      setState({
        search: {
          open: !state.search.open
        }
      });
    };
    $[27] = state.search.open;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  useHotkeys(t3, t4);
  let t5;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      modifiers: ["meta"],
      key: "k"
    };
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== state.search.open) {
    t6 = ev_0 => {
      ev_0.preventDefault();
      setState({
        search: {
          open: !state.search.open
        }
      });
    };
    $[30] = state.search.open;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  useHotkeys(t5, t6);
  let t7;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      key: "escape"
    };
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== state.search.open) {
    t8 = ev_1 => {
      if (state.search.open) {
        ev_1.preventDefault();
        setState({
          search: {
            open: false
          }
        });
      }
    };
    $[33] = state.search.open;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  useHotkeys(t7, t8);
  let t9;
  if ($[35] !== search) {
    t9 = search && {
      open: () => {
        setState({
          search: {
            open: true
          }
        });
      },
      ...search
    };
    $[35] = search;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t9 || $[38] !== toc) {
    t10 = <Sidebar sx={styles.sidebar} toc={toc} search={t9} />;
    $[37] = t9;
    $[38] = toc;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = stylex.props(styles.content, layoutStyles.grid);
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== children) {
    t12 = <div {...t11}>{children}</div>;
    $[41] = children;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== navigation || $[44] !== toc) {
    t13 = <NavigationFooter navigation={navigation} toc={toc} />;
    $[43] = navigation;
    $[44] = toc;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== Footer) {
    t14 = Footer && <Footer />;
    $[46] = Footer;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== t13 || $[49] !== t14) {
    t15 = <div className="xr1yuqi">{t13}{t14}</div>;
    $[48] = t13;
    $[49] = t14;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== t12 || $[52] !== t15) {
    t16 = <div className="x78zum5 xdt5ytf x1fdo2jl">{t12}{t15}</div>;
    $[51] = t12;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== rest || $[55] !== t10 || $[56] !== t16) {
    t17 = <Root {...rest} className="xg6iff7 x1hz7z82 xrvj5dj xc0s83b x1i3za4p xoxwh6b x1w3eerp x1p7i66b xdvd4st x1746jcd x6u19be x13xho20 x1b7vwdu x1cdhzux">{t10}{t16}</Root>;
    $[54] = rest;
    $[55] = t10;
    $[56] = t16;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => {
      setState({
        search: {
          open: false
        }
      });
    };
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== state.search.open) {
    t19 = <Commands open={state.search.open} onClose={t18} />;
    $[59] = state.search.open;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== context || $[62] !== t17 || $[63] !== t19) {
    t20 = <Provider value={context}>{t17}{t19}</Provider>;
    $[61] = context;
    $[62] = t17;
    $[63] = t19;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  return t20;
}
const styles = {
  sidebar: {
    kJuA4N: "x1nkj2r4",
    kY2c9j: "x13tdkmf",
    kVAEAm: "x7wzq59",
    k87sOh: "x13vifvy",
    kWkggS: "x1b7vwdu",
    kZ9C5d: "x1b3g1kt",
    kYjXgR: "x1uk07ai",
    kY6lvZ: "xbvzrs5",
    kTTLU8: "x1i1dbpq",
    kMbnel: "xzfhgub",
    kg8xMQ: "x3f8au3",
    $$css: true
  },
  content: {
    kTgw9: "x13faqbe",
    $$css: true
  }
};
function useHotkeys(trigger, callback) {
  const $ = _c(8);
  let t0;
  if ($[0] !== callback || $[1] !== trigger) {
    t0 = {
      trigger,
      callback
    };
    $[0] = callback;
    $[1] = trigger;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const ref = React.useRef(t0);
  let t1;
  if ($[3] !== callback || $[4] !== trigger) {
    t1 = () => {
      ref.current = {
        trigger,
        callback
      };
    };
    $[3] = callback;
    $[4] = trigger;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  React.useLayoutEffect(t1);
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleKeyDown = event => {
        if (ref.current.trigger.key.toLowerCase() !== event.key.toLowerCase()) {
          return;
        }
        const allModifiers = ["alt", "ctrl", "meta", "shift"];
        const expectedModifiers = ref.current.trigger.modifiers ?? [];
        for (const modifier of allModifiers) {
          if (event[`${modifier}Key`] !== expectedModifiers.includes(modifier)) {
            return;
          }
        }
        ref.current.callback(event);
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    };
    t3 = [];
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  React.useEffect(t2, t3);
}